import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import RpTable from 'rp-react-table';
import Select from '../../shared/Select';
import columns from './columns';

class Details extends PureComponent {
    constructor(props) {
        super(props);
        this.state = { selectValue: 0 };
    }

    onSelect = (val) => {
        this.setState({ selectValue: +val });
    }

    render() {
        const { selectValue } = this.state;
        const { data, type } = this.props;
        if (!data.length) {
            return null;
        }

        const { race, season } = data[selectValue].title;
        const isIreSelected = race.includes('IRE');
        const classPrefix = type === 'jockey' ? 'jockey' : 'notJockey';

        return (
            <div className={`mp-details mp-details_${classPrefix}`}>
                <Select
                    value={selectValue}
                    options={data.map(item => item.title.option)}
                    onSelect={this.onSelect}
                    wrapperClass="pp-select_details"
                >
                    {race}&nbsp;
                    <span className="mp-details__season">{season}</span>
                </Select>
                <div className="mp-details__wrapper">
                    <RpTable
                        data={data[selectValue].rows}
                        footerData={data[selectValue].total}
                        columns={columns(type, isIreSelected)}
                        uiType={5}
                        initialSortIdx={0}
                    />
                </div>
            </div>
        );
    }
}

const rowPropTypes = PropTypes.shape({
    // common:
    groupName: PropTypes.string.isRequired,
    wins: PropTypes.number,
    runs: PropTypes.number,
    percent: PropTypes.number,
    placed: PropTypes.number,
    stake: PropTypes.oneOfType(
        [PropTypes.string, PropTypes.number]
    ),
    totalEarnings: PropTypes.string,
    // jockey:
    '2nd': PropTypes.number,
    '3rd': PropTypes.number,
    '4ths': PropTypes.number,
    winnings: PropTypes.string,
    // trainer & owner
    winsHorses: PropTypes.string,
    horseName: PropTypes.string,
    horseUid: PropTypes.number,
    rpr: PropTypes.number,
});

Details.propTypes = {
    data: PropTypes.arrayOf(PropTypes.shape({
        rows: PropTypes.arrayOf(rowPropTypes),
        title: PropTypes.shape({
            option: PropTypes.string.isRequired,
            race: PropTypes.string.isRequired,
            season: PropTypes.string.isRequired,
        }),
        total: rowPropTypes,
    })).isRequired,
    type: PropTypes.string.isRequired,
};


export default Details;



// WEBPACK FOOTER //
// ./src/js/human/details/Details.jsx